<script>
  import { layoutMethods, gbitsEloadTopupMethods } from "@/state/helpers";
  import vue2Dropzone from "vue2-dropzone";
  import "vue2-dropzone/dist/vue2Dropzone.min.css";
  import shortid from "shortid";
  import Swal from "sweetalert2";

  /**
   * Eload b2b action component
   */
  export default {
    props:{
        view: String,
        requestData: Object,
        userAccess: Object
    },
    page: {
      title: "eLoad B2B Action"
    },
    components: {
        vueDropzone: vue2Dropzone,
    },
    computed: {
    },
    data() {
      return {
        title: "eLoad B2B Action",
        rejectForm:{
            confirm: false,
            reason:null,
            remarks:null
        },
        reasonOptions:[
            {text: 'Select Reason', value: null, $disabled: true},
            {text: 'Incomplete or Incorrect Documentation', value: 'Incomplete or Incorrect Documentation'},
            {text: 'Banking Relationship Issues', value: 'Banking Relationship Issues'},
            {text: 'Risk of Fraud or Suspicious Activity', value: 'Risk of Fraud or Suspicious Activity'},
            {text: 'Others', value: 'Others'}
        ],
        dropzoneOptions: {
            url: '/',//'https://httpbin.org/post', //
            maxFiles: 1,                  // Allow only one file to be uploaded
            maxFilesize:10,
            // Restrict to only the file types actually supported by the upload
            // pipeline (see allowedType in uploadEloadB2BDepositImg). Using the
            // broader 'image/*' here would let e.g. gif/webp/svg pass this check
            // and reach the Confirm button, only to fail later on upload.
            acceptedFiles: '.jpg,.jpeg,.png,image/jpeg,image/png',
            dictDefaultMessage: 'Drop an image here or click to upload.',
            dictMaxFilesExceeded: 'You can only upload one image.',
            dictInvalidFileType: 'Only JPG and PNG images are allowed.',
            thumbnailWidth: 150,          // Thumbnail width (optional)
            thumbnailHeight: 150,         // Thumbnail height (optional)
            addRemoveLinks: true,        // Enable remove button
            // autoProcessQueue: false,
        },
        proofOfConfirmationImg: {
            confirm: false,
            filename: null,
            type: null,
            base64: null,
        },
        s3key: null,
        isUploadingImg: false,
        uploadErrorMessage: null,
      };
    },
    methods: {
        ...layoutMethods,
        ...gbitsEloadTopupMethods,
        formatRequestId(item) {
            if (!item || !item.id) return "--";
            const date = item.deposit_date || item.created_at;
            if (!date) return item.id;
            const d = new Date(date);
            const yyyyMM = `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, '0')}`;
            const paddedId = String(item.id).padStart(5, '0');
            return `${yyyyMM}${paddedId}`;
        },
        openModal(modal=''){
            this.rejectForm = {
                confirm: false,
                reason:null,
                remarks:null
            }
            this.$bvModal.show(modal+this.requestData.id);
        },
        closeModal(modal=''){
            this.$bvModal.hide(modal+this.requestData.id);
        },
        async submitReject(){
            // console.log(">> rejectFrom",JSON.stringify(this.rejectForm))
            // //axios the api
            await this.postRejectedRequest({
                ...this.rejectForm,
                id: this.requestData.id,
                reference_number: this.requestData.reference_number,
            })
            .then((res)=>{
                console.log("Done Approving",res);
                Swal.fire("Successfully Rejected!", `The fund request has been successfully rejected.`, "success");
                this.closeModal("bv-modal-reject");
                this.reload();
            })
            .catch((err)=>{
                console.log("Error while rejecting:",err);
                Swal.fire("Failed!", err?.message?.description??`Unable to reject the request please try again later`, "error");
            });
        },
        async submitApproved(){
            this.openModal('bv-modal-approve');
        },
        async confirmApproved(){
            if (!this.proofOfConfirmationImg.confirm) {
                this.uploadErrorMessage = "Please upload proof of confirmation image.";
                return;
            }
            this.isUploadingImg = true;
            let isUploaded = await this.uploadProof();
            this.isUploadingImg = false;

            if (isUploaded) {
                await this.postApprovedRequest({
                    ...this.requestData,
                    proofKey: this.s3key
                })
                .then((res)=>{
                    console.log("Done Approving",res);
                    Swal.fire("Successfully Approved!", res?.message?.description || `The fund request has been successfully approved.`, "success");
                    this.closeModal("bv-modal-approve");
                    this.reload();
                })
                .catch((err)=>{
                    console.log("Error while approving:",err);
                    Swal.fire("Failed!", err?.message?.description || `Unable to approve the request please try again later`, "error");
                });
            }
        },
        getValidationState({ dirty, validated, valid = null }) {
            return dirty || validated ? valid : null;
        },
        handleSending(file){
            // console.log('File:', file);
            // console.log('xhr:', xhr);
            // console.log('formData:', formData);
            // console.log('generateShortId()', this.generateShortId());
            // console.log('file.dataURL', file.dataURL);
            // console.log('file.type.split("/")[1]', file.type.split("/")[1]);
            // console.log('buffer', new Buffer.from(file.dataURL.replace(/^data:image\/[a-zA-Z+]+;base64,/, ""), "base64"));
            // console.log('buffer', file[0]);
            
            this.proofOfConfirmationImg.filename    = `${this.generateShortId()}.${file.type.split("/")[1]}`
            this.proofOfConfirmationImg.type        = file.type.split("/")[1]

            const reader = new FileReader();
            reader.onloadend = () => {
                const base64Data = reader.result;
                // console.log(">>> base64Data:",base64Data);
                this.proofOfConfirmationImg.base64 = new Buffer.from(base64Data.replace(/^data:image\/[a-zA-Z+]+;base64,/, ""), "base64");
                this.proofOfConfirmationImg.confirm=true
                this.uploadErrorMessage = null
            };
            reader.readAsDataURL(file);
        },
        handleFileAdded(file) {
            // This method will be called when a file is added to the dropzone
            console.log('File added:', file);
            // If you want to automatically remove the previous file when a new file is added
            if (this.$refs.myDropzone.files.length > 1) {
                this.$refs.myDropzone.removeFile(this.$refs.myDropzone.files[0]);
            }
        },
        handleSuccess(file, response) {
            // Handle successful upload (if needed)
            console.log('File uploaded successfully:', file);
            console.log('Response:::', response);
            // console.log('generateShortId()', this.generateShortId());
            // console.log('file.dataURL', file.dataURL);
            // console.log('file.type.split("/")[1]', file.type.split("/")[1]);
            // console.log('buffer', new Buffer.from(file.dataURL.replace(/^data:image\/[a-zA-Z+]+;base64,/, ""), "base64"));
            
            this.proofOfConfirmationImg = {
                confirm: true,
                filename: `${this.generateShortId()}.${file.type.split("/")[1]}`,
                type: file.type.split("/")[1],
                base64: new Buffer.from(file.dataURL.replace(/^data:image\/[a-zA-Z+]+;base64,/, ""), "base64"),
            };
            // console.log('proofOfConfirmationImg:', this.proofOfConfirmationImg);

        },
        generateShortId(){
            return shortid.generate();
        },
        async uploadProof() {
            let isUploaded = false;
            if (this.proofOfConfirmationImg.base64) {
                var proofOfConfirmationImg = { ...this.proofOfConfirmationImg, accountId: this.requestData.account_id || this.requestData.user_id };

                await this.uploadEloadB2BDepositImg(proofOfConfirmationImg)
                .then((imageKey) => {
                    this.s3key = imageKey;
                    isUploaded = true;
                })
                .catch((err) => {
                    Swal.fire("Upload Failed!", `${err}`, "error");
                });
            } 

            return isUploaded;
        },
        async reload(){
            this.$emit('reload', this.requestData)
        },
        onFileError(file, errorMessage) {
            const dropzone = this.$refs.myDropzone.dropzone;
            console.log("Error on file:", errorMessage,dropzone.files.length);
            file.previewElement.querySelector('.dz-error-message').style.display = 'none';

            // Invalid file type: block the upload entirely, clear the broken preview,
            // and inform the user via a popup instead of the inline error text.
            if(errorMessage.includes("Only JPG and PNG")){
                this.proofOfConfirmationImg = {
                    confirm: false,
                    filename: null,
                    type: null,
                    base64: null,
                };
                this.uploadErrorMessage = null;
                dropzone.removeFile(file);
                Swal.fire("Invalid File Type!", "File type is not allowed. Please upload a JPG or PNG image.", "error");
                return;
            }

            if(
                errorMessage.includes("only upload one") ||
                errorMessage.includes("File is too big")
            ){
                this.proofOfConfirmationImg.confirm = false
                this.uploadErrorMessage = errorMessage
            }
            else if(dropzone.files.length>1){
                this.proofOfConfirmationImg.confirm = false
                this.uploadErrorMessage = "You can only upload one image."
            }
            // if(errorMessage.includes("DOCTYPE")){
            //     file.previewElement.querySelector('.dz-error-message').style.display = 'none';
            // }
        },
        onFileRemoved(file) {
            // Reset upload state so the Confirm button goes back to disabled,
            // since a proof image is required before the request can be approved.
            console.log('File removed:', file);
            this.proofOfConfirmationImg = {
                confirm: false,
                filename: null,
                type: null,
                base64: null,
            };
            this.s3key = null;
            this.uploadErrorMessage = null;
        }
    },
    async mounted(){
        // console.log(">>>>",this.generateShortId())
    }
  }
    
</script>
<style scoped>
    .custom-green{
        background: #508F30;
    }
    .custom-red{
        background: #BC3D40;
    }
    .fs-100{
        font-size: 100px;
    }
    ul {list-style-type: none;} 
    .form-check-input:checked {
        background-color: #BC3D40;
        border-color: #BC3D40;
    }
    .loading-container {
        position: fixed;  /* Fixed position to cover the entire viewport */
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #f3f3f3ca; /* Semi-transparent background */
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99999; /* Make sure it appears on top */
    }

    .loading-spinner {
        border: 8px solid #f3f3f3; /* Light grey background for spinner */
        border-top: 8px solid #7F4697; /* Blue color for the spinner */
        border-radius: 50%;
        width: 50px;
        height: 50px;
        animation: spin 2s linear infinite;
    }

    /* Spinner animation */
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

    .cw-110{
        width: 110px;
    }

    /* Proof of Confirmation modal - matches Figma node 6007:26378 */
    .poc-modal {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 24px;
        padding: 8px 16px 0;
    }
    .poc-check-icon {
        width: 90px;
        height: 90px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .poc-title {
        font-weight: 700;
        font-size: 24px;
        letter-spacing: 0.36px;
        color: #000;
        text-align: center;
        margin: 0;
    }
    .poc-details-box {
        background-color: rgba(242, 244, 247, 0.5);
        border-radius: 8px;
        padding: 16px;
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 12px;
    }
    .poc-details-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
    }
    .poc-label {
        font-size: 14px;
        color: #191c1e;
        font-weight: 400;
    }
    .poc-value {
        font-size: 14px;
        color: #202020;
        font-weight: 700;
    }
    .poc-instruction {
        font-size: 18px;
        letter-spacing: 0.27px;
        color: #000;
        text-align: center;
        margin: 0;
    }
    .poc-dropzone-wrap {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .compact-dropzone {
        background-color: #fafafa !important;
        border: 1px dashed #ce7bac !important;
        border-radius: 8px !important;
        min-height: 139px !important;
        width: 100%;
        max-width: 324px;
        padding: 24px 31px !important;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
    }
    .compact-dropzone .dropzone-custom-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
    }
    .compact-dropzone .dropzone-custom-content i {
        font-size: 42px;
        color: #e73092;
    }
    .compact-dropzone .dropzone-custom-content p {
        font-weight: 500;
        font-size: 12px;
        letter-spacing: 0.36px;
        color: #000;
        text-align: center;
        margin: 0;
    }
    ::v-deep .compact-dropzone .dz-preview {
        position: static;
        width: 121px;
        height: 107px;
        margin: 0;
        min-height: 0;
        overflow: hidden;
        border-radius: 8px;
    }
    ::v-deep .compact-dropzone .dz-preview .dz-image {
        border-radius: 8px;
        width: 121px;
        height: 107px;
        overflow: hidden;
    }
    ::v-deep .compact-dropzone .dz-preview .dz-image img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    /* Hide dropzone's built-in overlays not used by this upload flow (filename/size
       label, and success/error marks - upload is handled manually via presigned S3
       URL, not the dummy dropzone POST url, so these never reflect real state) */
    ::v-deep .compact-dropzone .dz-preview .dz-details,
    ::v-deep .compact-dropzone .dz-preview .dz-success-mark,
    ::v-deep .compact-dropzone .dz-preview .dz-error-mark,
    ::v-deep .compact-dropzone .dz-preview .dz-error-message,
    ::v-deep .compact-dropzone .dz-preview .dz-progress {
        display: none !important;
    }
    /* Delete button anchored inside the dropzone container's top-right corner */
    ::v-deep .compact-dropzone .dz-remove {
        position: absolute;
        top: 8px;
        right: 8px;
        left: auto;
        bottom: auto;
        width: 18px;
        height: 18px;
        padding: 0;
        margin: 0;
        border-radius: 50%;
        background-color: #c12927;
        color: transparent;
        font-size: 0;
        line-height: 18px;
        text-align: center;
        border: none;
        opacity: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 40;
    }
    ::v-deep .compact-dropzone .dz-remove::before {
        font-family: "boxicons" !important;
        content: "\eb7c";
        font-size: 10px;
        line-height: 1;
        color: #fff;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    ::v-deep .compact-dropzone .dz-remove:hover {
        background-color: #a52220;
        text-decoration: none;
    }
    .poc-actions {
        display: flex;
        gap: 10px;
        justify-content: center;
        width: 100%;
        max-width: 303px;
    }
    .poc-btn {
        flex: 1 0 0;
        min-width: 0;
        padding: 14px 20px;
        border-radius: 4px;
        font-size: 16px;
        font-weight: 500;
        letter-spacing: 0.24px;
        color: #fff;
        border: none;
    }
    .poc-btn-close {
        background-color: #e83092;
    }
    .poc-btn-close:hover {
        background-color: #d42883;
        color: #fff;
    }
    .poc-btn-confirm {
        background-color: #7f4697;
    }
    .poc-btn-confirm:hover:not(:disabled) {
        background-color: #6e3c83;
        color: #fff;
    }
    .poc-btn-confirm:disabled {
        background-color: #c8c8c8;
        opacity: 1;
    }
</style>
<template>
  <div><!-- outer div-->
      <div v-if="requestData.status == 'requesting' && userAccess.update">
        <div v-if="view=='list'">
            <b-button variant="success" class="p-1 me-2 custom-green" @click="submitApproved()">
                <i class="bx bx-check-circle bx-xs bx-fw"></i>
            </b-button>

            <b-button variant="danger" class="p-1 custom-red" @click="openModal('bv-modal-reject')"
                ><i class="bx bx-x-circle bx-xs bx-fw"></i>
            </b-button>
        </div>
        <div v-else>
            <b-button variant="success" class="p-1 me-2 custom-green cw-110" @click="submitApproved()">
                <i class="bx bx-check-circle bx-xs bx-fw"></i>
                Approve
            </b-button>

            <b-button variant="danger" class="p-1 custom-red cw-110" @click="openModal('bv-modal-reject')"
                ><i class="bx bx-x-circle bx-xs bx-fw"></i>
                Reject
            </b-button>
        </div>
      </div><!-- end of row-->

    <b-modal :id="`bv-modal-reject${requestData.id}`"
      centered
      hide-header
      hide-footer
      hide-header-close
    no-close-on-esc
    no-close-on-backdrop
    >
        <div class="row text-center">
            <h1 class="col-12"><i class="bx bx-info-circle text-info fs-100"></i></h1>
            <h2 class="col-12">Reject Fund Request</h2>
            <p>Are you sure you want to reject this fund request? This action cannot be undone.</p>
            <ul>
                <li>
                    <span class="fw-semibold">Merchant Name:</span> {{ requestData?.name??requestData?.merchantName??null | notEmpty }}
                </li>
                <li>
                    <span class="fw-semibold">Payment Reference Number:</span> {{ requestData.reference_number }}
                </li>
                <li>
                    <span class="fw-semibold">Deposit Amount:</span> PHP {{ requestData.deposit_amount | numberWithCommas }}
                </li>
                <li>
                    <span class="fw-semibold">Default Rebate:</span> {{ requestData.rebate_percentage || 0 }}%
                </li>
                <li>
                    <span class="fw-semibold">Topup Amount:</span> PHP {{ requestData.topup_amount | numberWithCommas }}
                </li>
            </ul>
        </div>

        <ValidationObserver v-slot="{ handleSubmit, reset }">
            <b-form @submit.prevent="handleSubmit(submitReject)" @reset.prevent="reset">
                <div class="form-group mb-3">
                    <div class="form-check mt-3 d-flex justify-content-center">
                        <input type="checkbox" id="formrow-customCheck" class="form-check-input me-3" v-model="rejectForm.confirm" style="border-color:#BC3E40;">
                        <label for="formrow-customCheck" class="form-check-label">Please confirm that you want to reject the request. </label>
                    </div>
                </div>

                <b-col sm="12" class="mb-3" v-if="rejectForm.confirm"><!--Reason-->
                    <validation-provider name="Reason" rules="required" v-slot="validationContext">
                        <b-form-group>
                            <b-form-select class="form-select rounded-0 rounded-start rounded-end shadow-none custom-select w-100" style="width:160px"
                                id="change-type"
                                v-model="rejectForm.reason"
                                :options="reasonOptions"
                                :state="getValidationState(validationContext)"
                            ></b-form-select>
                        </b-form-group>
                        <b-form-invalid-feedback>
                            {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                    </validation-provider>
                </b-col><!--Reason-->

                <b-col sm="12" class="mb-3 text-left" v-if="rejectForm.reason == 'Others' && rejectForm.confirm"><!--Reason-->
                    <validation-provider name="Remarks" rules="required" v-slot="validationContext">
                        <div>
                            <span class="text-muted float-end">{{rejectForm.remarks == null ? 0 : rejectForm.remarks.length}}/100 characters limit</span>
                            <label>Remarks <span class="text-danger">*</span></label>
                            <b-form-textarea
                                v-model="rejectForm.remarks"
                                placeholder="Enter your remarks here..."
                                rows="2"
                                max-rows="3"
                                :maxlength="100"
                                :state="getValidationState(validationContext)"
                            ></b-form-textarea>
                            <b-form-invalid-feedback>
                                {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                        </div>
                    </validation-provider>
                </b-col><!--Reason-->

                <div class="text-center">
                    <b-button type="button" variant="primary" class="me-2" @click="closeModal(`bv-modal-reject`)">
                        No, Cancel
                    </b-button>
                    <b-button type="submit" variant="secondary" :disabled="!rejectForm.confirm || (rejectForm.reason == null) || (rejectForm.reason == 'Others' && rejectForm.remarks == null)">
                        Yes, Reject Request 
                        <!-- {{ (rejectForm.reason == null)}} {{ !rejectForm.confirm }} -->
                    </b-button>
                </div>
            </b-form>
        </ValidationObserver>
    </b-modal>

    <!-- Proof of Confirmation upload modal -->
    <b-modal :id="`bv-modal-approve${requestData.id}`"
        centered
        hide-header
        hide-footer
        hide-header-close
        no-close-on-esc
        no-close-on-backdrop
    >   
        <div class="poc-modal">
            <div class="loading-container" v-if="isUploadingImg">
                <div class="loading-spinner"></div>
                <p class="loading-text ms-3">Uploading Img...</p>
            </div>
            <div class="poc-check-icon">
                <img src="@/assets/images/info-circle.svg" alt="Info" width="90" height="90">
            </div>
            <p class="poc-title">Proof of Confirmation</p>
            <div class="poc-details-box">
                <div class="poc-details-row">
                    <span class="poc-label">Request ID:</span>
                    <span class="poc-value">{{ formatRequestId(requestData) }}</span>
                </div>
                <div class="poc-details-row">
                    <span class="poc-label">Business Name:</span>
                    <span class="poc-value">{{ requestData?.business_name || requestData?.businessName || '--' }}</span>
                </div>
                <div class="poc-details-row">
                    <span class="poc-label">Deposit Amount :</span>
                    <span class="poc-value">PHP {{ requestData.deposit_amount | numberWithCommas }}</span>
                </div>
            </div>
            <p class="poc-instruction">Please upload the deposit screenshot as proof of confirmation.</p>
            <div class="poc-dropzone-wrap">
                <vue-dropzone
                    id="proofOfConfirmation"
                    ref="myDropzone"
                    :use-custom-slot="true"
                    :options="dropzoneOptions"
                    @vdropzone-success="handleSuccess"
                    @vdropzone-addedfile="handleFileAdded"
                    @vdropzone-sending="handleSending"
                    @vdropzone-error="onFileError"
                    @vdropzone-removed-file="onFileRemoved"
                    class="compact-dropzone"
                >
                    <div class="dropzone-custom-content">
                        <i class="bx bx-upload"></i>
                        <p class="mb-0">Drop files or click to upload</p>
                    </div>
                </vue-dropzone>
                <span class="text-danger fw-semibold" v-if="uploadErrorMessage != null">{{ uploadErrorMessage }}</span>
            </div>
            <div class="poc-actions">
                <b-button type="button" class="poc-btn poc-btn-close" @click="closeModal(`bv-modal-approve`)">
                    Close
                </b-button>
                <b-button type="submit" class="poc-btn poc-btn-confirm" :disabled="!proofOfConfirmationImg.confirm" @click="confirmApproved">
                    Confirm
                </b-button>
            </div>
        </div>
    </b-modal>
  </div> <!-- end of outer div-->
</template>
<!-- 
{{ view }}
{{ requestData }} -->